import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";
import { CtBinaryOperator, CtButtonConfiguration, CtDatatableComponent, CtDatatableConfiguration, CTDatatablePaginationParameter, CtFormContainerHelper, CtModelConfiguration, CTModelDatatableFilter, CtModelDatatableOperators, CtModelService, CtSortOrderDescriptorParameter, MAT_RAISED_PRIMARY, MAT_RAISED_WARN } from '@ctsolution/ct-framework';
import { LeadRouteData } from '../../../_core/route-data/lead.route-data';
import { SelectionType } from '@swimlane/ngx-datatable';
import { LEAD_CUSTOMER_SELECTION_COLUMNS } from './lead-customer-columns';
import { CompanyType } from '../../../_core/enum/company-type';

@Component({
  selector: 'app-lead-selection',
  templateUrl: './lead-selection.component.html',
  styleUrls: ['./lead-selection.component.scss']
})
export class LeadSelectionComponent {


  @ViewChild(CtDatatableComponent) datatable: CtDatatableComponent | null = null;

  cancelButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("CT_PAGE.CT_FORM.cancel")
    .setAction(() => this.onCancel())
    .setMatherialOptions(MAT_RAISED_WARN);

  submitButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("CT_PAGE.CT_FORM.save")
    .setClass('ct-model-submit-button')
    .setAction(() => this.onSubmit())
    .setMatherialOptions(MAT_RAISED_PRIMARY);

  list: CtDatatableConfiguration = CtDatatableConfiguration
    .create()
    .setScrollbarH(true)
    .setFiltersEnabled(true)
    .setExternalSorting(true)
    .setStartUpValues(null)
    .setLimit(5);

  private Filters: any | null = null;
  private ColumnPrimarySorting: CtSortOrderDescriptorParameter | null = null;
  configuration: CtModelConfiguration<any> | null = null;


  constructor(
    private modelService: CtModelService<any>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialog: MatDialogRef<LeadSelectionComponent>,
    private ctFormContainerHelper: CtFormContainerHelper) {

    this.list
      .setSelectionType(SelectionType.single)
      .setColumns(LEAD_CUSTOMER_SELECTION_COLUMNS)
      .setController('Lead');

    this.configuration = CtModelConfiguration
      .create()
      .setRouteData(LeadRouteData())

  }

  ngAfterViewInit(): void {

    setTimeout(() => {

      this.datatable
        ?.form
        .reset({}, { emitEvent: false })
      window.dispatchEvent(new Event("resize"));

    }, 250);

  }

  getFilters(): CTModelDatatableFilter[] {

    const filters: CTModelDatatableFilter[] = new Array<CTModelDatatableFilter>();

    filters
      .push(
        CTModelDatatableFilter
          .create()
          .setField("[CustomerType.Type] is not null AND [CustomerType.Type] = ?")
          .setValue([CompanyType.Private])
          .setOperatorType(CtBinaryOperator.OrOperator),
      );
    filters
      .push(
        CTModelDatatableFilter
          .create()
          .setField("[Customer.Type.Type] is not null AND [Customer.Type.Type] = ?")
          .setValue([CompanyType.Private])
          .setOperatorType(CtBinaryOperator.OrOperator),
      );


    return filters;

  }

  onSort(event: any) {

    this.ColumnPrimarySorting = this.ctFormContainerHelper.setupCTLookupInfoSortingValues(this.configuration!, event.sorting);

    if(this.ColumnPrimarySorting.Field === 'TagsJoined')
      this.ColumnPrimarySorting = null;

    this.fetchData();

  }

  fetchData(pagination?: CTDatatablePaginationParameter): void {

    this.list.setLoadingIndicator(true);

    this.caller(pagination)
      .subscribe(response => {

        this.list
          .setCount(response?.Result?.TotalElement ?? 0)
          .setRows((response?.Result?.DataSource ?? []) as any[])
          .setLoadingIndicator(false);

      });

  }

  private caller(pagination?: CTDatatablePaginationParameter) {

    const body: CtModelDatatableOperators = CtModelDatatableOperators.create()
      .setFilters()

    if (pagination) {

      body
        .setPagination(pagination)

    }

    if (this.Filters) {

      body
        .setFiltersByKeyValueObject(this.Filters, this.configuration!.CTFieldInfos ?? []);

    }

    if (!body.Filters) {

      body
        .setFilters(new Array<CTModelDatatableFilter>())

    }

    body
      .Filters
      .push(...this.getFilters())

    if (body.Filters.length && !pagination) { // se ho dei filtri presenti e pagination non è valorizzata (quindi non provengo dal click del paginatore) riparto da pagina 1

      body
        .Pagination
        ?.setPage(1);

    }

    if (this.ColumnPrimarySorting) {

      body
        .Pagination
        ?.setSortOrders([this.ColumnPrimarySorting]);

    } else {

      body
        .Pagination
        ?.setSortOrders(
          new Array<CtSortOrderDescriptorParameter>(CtSortOrderDescriptorParameter.create('Code')))

    }


    if (body.Filters) {
      const updatedFilters: CTModelDatatableFilter[] = [];

      for (const filter of body.Filters) {
        if (filter.Field === 'Tags' && Array.isArray(filter.Value)) {
          for (const tag of filter.Value) {
            updatedFilters.push(
              CTModelDatatableFilter
                .create()
                .setField("[Tags][[Oid] == ?].Exists()")
                .setValue([tag._value])
                .setOperatorType(CtBinaryOperator.AndOperator)
            );
          }
        } else {
          updatedFilters.push(filter); // mantieni gli altri filtri intatti
        }
      }

      body.Filters = updatedFilters;
    }

    return this.modelService
      .getList(this.configuration!, body);

  }

  onCancel() {

    this.dialog
      .close();

  }

  search(event: { [key: string]: any; } | null = null) {

    this.Filters = event ? this.ctFormContainerHelper.setupCTLookupInfoControlValues(this.configuration!, event, true) : null;

    if (!this.Filters) {

      this.datatable
        ?.form
        .reset({}, { emitEvent: false })

    } else {

      this.datatable
        ?.form
        .patchValue(this.Filters ?? {}, { emitEvent: false });

    }

    this.fetchData();

  }

  onSubmit() {

    const selected = this.list.selected;

    this.dialog
      .close(selected);

  }

}
